import { useReveal } from "../../lib/useReveal";

const steps = [
    {
        n: "01",
        title: "Seleção do mercado",
        body: "Estudamos margem, capacidade operacional, ticket, ciclo de venda e estrutura interna. Só avançamos onde existe espaço real para escala.",
    },
    {
        n: "02",
        title: "Investimento em aquisição",
        body: "Aportamos capital próprio em mídia, dados e infraestrutura de prospecção. O risco da geração de demanda é nosso.",
    },
    {
        n: "03",
        title: "Operação comercial",
        body: "Montamos e dirigimos a estrutura de pré-venda, qualificação, abordagem e follow-up. Padronizamos a abordagem e o discurso.",
    },
    {
        n: "04",
        title: "Conversão",
        body: "Fechamos. Nossos closers operam dentro de scripts validados, ofertas testadas e cadência sob controle direto. Receita rastreável.",
    },
    {
        n: "05",
        title: "Participação sobre receita",
        body: "Recebemos exclusivamente sobre o que entra. Sem fee. Sem mensalidade. Sem relatório vendido como entregável.",
    },
];

export default function ComoOperamos() {
    const ref = useReveal();
    return (
        <section
            data-testid="como-operamos"
            id="como-operamos"
            className="relative py-28 lg:py-40 border-t border-white/5 bg-[#070707]"
        >
            <div ref={ref} className="reveal max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex items-center gap-4 mb-10">
                    <span className="h-px w-10 bg-[#d4af37]" />
                    <span className="tag-fluxo">Operação</span>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-24">
                    <h2 className="lg:col-span-7 font-['Outfit'] font-bold uppercase tracking-[-0.02em] text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
                        Como operamos<br />
                        <span className="text-gold-gradient">crescimento</span>.
                    </h2>
                    <p className="lg:col-span-5 text-white/55 leading-relaxed text-base md:text-lg self-end">
                        Cinco etapas integradas sob comando único. Não delegamos.
                        Não terceirizamos. Não dependemos da estrutura interna do
                        cliente para gerar receita.
                    </p>
                </div>

                <div className="relative">
                    {/* Vertical gold line */}
                    <div className="absolute left-[20px] md:left-[30px] top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#d4af37]/40 to-transparent" />

                    <div className="space-y-14 md:space-y-20">
                        {steps.map((s, i) => (
                            <div
                                key={s.n}
                                data-testid={`step-${s.n}`}
                                className="relative pl-16 md:pl-28 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 group"
                            >
                                {/* Bullet */}
                                <div className="absolute left-[14px] md:left-[24px] top-3 w-3 h-3 bg-[#d4af37] rotate-45 ring-4 ring-[#070707]" />

                                <div className="md:col-span-3">
                                    <div className="step-num">{s.n}</div>
                                </div>
                                <div className="md:col-span-9 md:pt-4">
                                    <h3 className="text-white font-['Outfit'] font-semibold text-2xl md:text-3xl mb-4">
                                        {s.title}
                                    </h3>
                                    <p className="text-white/55 leading-relaxed max-w-2xl text-base md:text-[17px]">
                                        {s.body}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
